import React, { useEffect, useState } from "react";
import "../../pages/styles/Productos.css";
import "jspdf-autotable";
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from "match-sorter";
import LinkButton from "../LinkButton";
import swal from "sweetalert";
import { notificarError, notificarMsg } from "../Almacenes/AlmacenNotify";


export default function List() {
    const [insumos, setInsumos] = useState([]);

    useEffect(() => {
        fetchInsumos();
    }, [])

    const fetchInsumos = async () => {
        const req = await fetch(`/api/insumos/`);
        const response = await req.json();

        setInsumos([ ...response]);
    }

    const eliminarInsumo = async (id) => {
        const req = await fetch(`/api/insumos/${id}`, {
            method: 'DELETE'
        });

        if (req.ok) {
            notificarMsg("Se eliminó el insumo correctamente");
        } else {
            notificarError("No se pudo eliminar el insumo");
        }

        fetchInsumos();
    }

    const handleDelete = async (IdInsumo) => {
        const willDelete = await swal({
            title: "¿Está seguro?",
            text: "¿Desea borrar este insumo?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            closeOnClickOutside: false
        });

        if (willDelete)
            eliminarInsumo(IdInsumo);
    }

    return <>
        <section className="ventas-fpay-section-vh pt-5">
            <div className="container">
                <div className="ProcesarBoton mt-1 mb-3">
                    <div className="ProcesarBotones">
                        <LinkButton to="/insumos/form" className="btn-verde-mfp mr-2">
                            <span className="text-22px-20pxresp">Registrar insumo</span>
                        </LinkButton>
                    </div>

                </div>
                {
                    <ReactTable
                        id="table-productos-to-xls"
                        data={insumos}
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value
                        }
                        manual={true}
                        filterable={true}
                        sortable={true}
                        columns={[
                            {
                                columns: [
                                    {
                                        Header: "Opciones",
                                        id: "id",
                                        width: 220,
                                        accessor: d => d.IdInsumo,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {
                                                keys: ["id"]
                                            }),
                                        Cell: f => {
                                            return (
                                                <div align="center">
                                                    <LinkButton
                                                        to={`/insumos/form/${f.value}`}
                                                        className="btn-naranja-mfp"
                                                        style={{fontSize: "16px"}}
                                                    >
                                                        {<a className="">Editar</a>}
                                                    </LinkButton>
                                                    <button
                                                        id={f.value}
                                                        value={f.original.IdInsumo}
                                                        type="button"
                                                        className="btn-anular ml-1"
                                                        style={{fontSize: "16px"}}
                                                        onClick={() => handleDelete(f.original.IdInsumo)}
                                                    >
                                                        {<a className="">Borrar</a>}
                                                    </button>
                                                </div>
                                            );
                                        },

                                        filterAll: true
                                    },
                                    {
                                        Header: "Código",
                                        id: "codigo",
                                        width: 90,
                                        accessor: d => d.Codigo,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Codigo"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "CodigoBarra",
                                        id: "CodigoBarra",
                                        width: 110,
                                        accessor: d => d.CodigoBarra,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["CodigoBarra"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Nombre",
                                        id: "Nombre",
                                        width: 350,
                                        accessor: d => d.Nombre,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Nombre"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Categoria",
                                        id: "Categoria",
                                        width: 250,
                                        accessor: d => d.Categoria,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {keys: ["Categoria"]}),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Unidad de Medida",
                                        id: "Unidad",
                                        accessor: d => d.Unidad,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {
                                                keys: ["Unidad"]
                                            }),
                                        filterAll: true
                                    },
                                    {
                                        Header: "Tipo de Afectación IGV",
                                        id: "AfectacionIgv",
                                        accessor: d => d.AfectacionIgv,
                                        filterMethod: (filter, rows) =>
                                            matchSorter(rows, filter.value, {
                                                keys: ["AfectacionIgv"]
                                            }),
                                        filterAll: true
                                    },
                                ]
                            }
                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        previousText="Anterior"
                        nextText="Siguiente"
                        noDataText="No se encontraron registros"
                        loadingText="Cargando..."
                        ofText="de"
                        rowsText="filas"
                        pageText="Página"
                        pageSizeOptions={[10, 20, 25, 50, 100]}
                    />
                }
            </div>
        </section>
    </>
};
